import { render, staticRenderFns } from "./ShopPopulars.vue?vue&type=template&id=92a5b91e&scoped=true"
import script from "./ShopPopulars.vue?vue&type=script&lang=js"
export * from "./ShopPopulars.vue?vue&type=script&lang=js"
import style0 from "./ShopPopulars.vue?vue&type=style&index=0&id=92a5b91e&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "92a5b91e",
  null
  
)

export default component.exports